module.exports = __webpack_public_path__ + "img/benoit1.ae2f1c7a.jpg";